import React from "react"

import NewOriginalDropdown from "./NewOriginalDropdown"

export default function AxesLabelsColumn({
  axisTagList,
  isNewLabel,
  setIsNewLabel,
  axisLabel,
  onLabelChange,
  label,
  intl,
}) {
  return (
    <div className={"col-6"}>
      {axisTagList.length > 0 && (
        <div className={"row"} style={{ margin: "0" }}>
          <div className={"col-3"} style={{ paddingLeft: "0" }}>
            <NewOriginalDropdown
              isNew={isNewLabel}
              intl={intl}
              onSelect={setIsNewLabel}
              id={"axis-label-toggle"}
            />
          </div>
          <div className={"col-3"} style={{ padding: "0" }}>
            <label>{label}:</label>
          </div>
          <div className={"col-6"} style={{ padding: "0" }}>
            <textarea
              style={{ width: "100%" }}
              rows={"2"}
              value={axisLabel}
              onChange={(ev) => onLabelChange(ev.target.value)}
            />
          </div>
        </div>
      )}
    </div>
  )
}
